import './recharge-theme.css';
import React from "react";
import FairmentFragebogenB from "./FairmentFragebogenB";

export default function App() {
  // Panel-Fragebogen zeigt nur Fragebogen B (für Neukunden)
  return <FairmentFragebogenB fragebogenType="B" />;
}